// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__3ztp6","addWidgetButton":"Header_addWidgetButton__19_IV","dashboardTabs":"Header_dashboardTabs__2XPVe","active":"Header_active__2QbBR"};